// Dispute statuses accepted by the backend (VALID_DISPUTE_STATUSES).
export const DISPUTE_STATUS = {
    OPENED: "DISPUTE_OPENED",
    AWAITING_RESPONSE: "DISPUTE_AWAITING_RESPONSE",
    UNDER_REVIEW: "DISPUTE_UNDER_REVIEW",
    DECIDED_BUYER: "DISPUTE_DECIDED_BUYER",
    DECIDED_SELLER: "DISPUTE_DECIDED_SELLER",
    CLOSED: "DISPUTE_CLOSED",
    BUYER_RETURN_APPROVE: "BUYER_RETURN_APPROVE",
};

// Order in which the statuses are offered to the admin
export const DISPUTE_STATUS_LIST = Object.values(DISPUTE_STATUS);

// Statuses that are considered final admin decisions
export const FINAL_DISPUTE_STATUSES = [
    DISPUTE_STATUS.DECIDED_BUYER,
    DISPUTE_STATUS.DECIDED_SELLER,
    DISPUTE_STATUS.CLOSED,
    DISPUTE_STATUS.BUYER_RETURN_APPROVE,
];

export const DISPUTE_STATUS_TRANSLATION_KEY = {
    [DISPUTE_STATUS.OPENED]: "disputeDetails.statusDisputeOpened",
    [DISPUTE_STATUS.AWAITING_RESPONSE]: "disputeDetails.statusAwaitingResponse",
    [DISPUTE_STATUS.UNDER_REVIEW]: "disputeDetails.statusUnderReview",
    [DISPUTE_STATUS.DECIDED_BUYER]: "disputeDetails.statusBuyerWins",
    [DISPUTE_STATUS.DECIDED_SELLER]: "disputeDetails.statusSellerWins",
    [DISPUTE_STATUS.CLOSED]: "disputeDetails.statusClosed",
    [DISPUTE_STATUS.BUYER_RETURN_APPROVE]: "disputeDetails.statusReturnApproved",
};

const DISPUTE_STATUS_TAG_CLASS = {
    [DISPUTE_STATUS.OPENED]: "pending",
    [DISPUTE_STATUS.AWAITING_RESPONSE]: "review",
    [DISPUTE_STATUS.UNDER_REVIEW]: "review",
    [DISPUTE_STATUS.DECIDED_BUYER]: "approved",
    [DISPUTE_STATUS.DECIDED_SELLER]: "approved",
    [DISPUTE_STATUS.CLOSED]: "draft",
    [DISPUTE_STATUS.BUYER_RETURN_APPROVE]: "return_approve",
};

export const normalizeDisputeStatus = (status) => status?.toString().toUpperCase() || "";

export const disputeTagClass = (status) =>
    DISPUTE_STATUS_TAG_CLASS[normalizeDisputeStatus(status)] || "";

export const disputeStatusLabel = (status, t) => {
    const key = DISPUTE_STATUS_TRANSLATION_KEY[normalizeDisputeStatus(status)];
    return key ? t(key) : status;
};
